module.exports = __webpack_public_path__ + "img/homepage_3@3x.ac72d724.jpg";